module.exports = __webpack_public_path__ + "static/tartaglia-selected-7e44859a9368b341a5bdec8a5f5588f1.png";